module.exports = __webpack_public_path__ + "img/intro-oasis-text.33d0cc03.png";